import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, Button, TextField } from "@material-ui/core";
import { isIE } from "react-device-detect";
import { FormattedMessage } from "react-intl";
import messages from "./constants/messages";
import { styles } from "./constants/styles";
import { RequestStatus, AuthError } from "../../shared";
import { State } from "./constants/types";

type Props = {
  stateAuth: State;
  errorStatus: AuthError | null;
  requestStatus: RequestStatus;
  resetPassword: () => void;
  handleChangeText: (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => void;
} & WithStyles<typeof styles>;

const ForgotPasswordForm: React.FC<Props> = (props: Props) => {
  const { classes, stateAuth: state, errorStatus, requestStatus, resetPassword, handleChangeText } = props;
  let errorMessage = messages.serverError;
  if (requestStatus === RequestStatus.Fail) {
    switch (errorStatus) {
      case AuthError.EmailExists:
        errorMessage = messages.resetPasswordEmailNoExistsError;
        break;
      default:
        break;
    }
  }
  return (
    <Box className={classes.modalBox}>
      <Typography className={classes.resetFormHeader}>
        <FormattedMessage {...messages.resetHeader} />
      </Typography>
      <Typography className={classes.resetFormConent}>
        <FormattedMessage {...messages.resetConent} />
      </Typography>
      <TextField
        id="resetPassword"
        fullWidth
        margin="normal"
        name="resetPassword"
        InputLabelProps={{
          shrink: isIE ? true : undefined,
          classes: { root: classes.inputLabel },
        }}
        label={<FormattedMessage {...messages.resetFormInputLabel} />}
        value={state.resetLogin}
        onChange={handleChangeText("resetLogin")}
        error={state.errors.resetLogin || state.errors.resetDomain}
        helperText={
          (Object.values(state.errors).some((error) => error === true) && (
            <FormattedMessage {...messages.errorMessage} />
          )) ||
          (requestStatus === RequestStatus.Fail && <FormattedMessage {...errorMessage} />)
        }
        FormHelperTextProps={{ classes: { root: classes.helperText } }}
        classes={{ root: classes.textFieldResetPassword }}
      />
      <div className={classes.resetFormActions}>
        <Button
          variant="contained"
          color="primary"
          onClick={resetPassword}
          disabled={requestStatus === RequestStatus.Pending}
        >
          <FormattedMessage {...messages.resetSubmit} />
        </Button>
      </div>
    </Box>
  );
};

export default withStyles(styles)(ForgotPasswordForm);
